import { IOverviewPageProps } from "./OverviewPage.types";
import { MicrositeHeading } from "pages/LayoutComponents/MicrositeHeading";
import { UniFiGPT } from "pages/LayoutComponents/UniFiGpt";
import { useTranslation } from "hooks/useTranslation";
import { ModelCompareV4 } from "@ubnt/store.core/lib/components/ModelCompareV4/ModelCompareV4";
import React, { Fragment } from "react";
import { BrandPrinciplesHero } from "components/BrandPrinciplesHero";
import { OverviewHero } from "pages/LayoutComponents/OverviewHero";
import { StyledContainer } from "components/StyledContainer";
import { StyledQuestions } from "components/StyledQuestions";
import { MODEL_COMPARE_STICK_OFFSET_CORRECTION } from "util/constants";
import { useInitialAutoscrollToFragment } from "hooks/useInitialAutoscrollToFragment";
import { HEADER_NAVIGATION_CAROUSEL_STICKY_TRANSITION_OFFSET } from "@ubnt/store.core/lib/components/Header/Navigation/Carousel/Carousel.styles";
import { MODEL_COMPARE_V4_ANCHOR } from "@ubnt/store.core/lib/components/ModelCompareV4/ModelCompareV4";
import { CondensedFeatureGridInView } from "pages/LayoutComponents/CondensedFeatureGrid/CondensedFeatureGridInView";
import { InView } from "react-intersection-observer";

export const OverviewPage = ({
  featureConfig,
  faq,
  brandPrinciples,
  heroSections,
  compare,
}: Readonly<IOverviewPageProps>) => {
  const { t } = useTranslation();

  useInitialAutoscrollToFragment({
    delay: 200,
    offset: HEADER_NAVIGATION_CAROUSEL_STICKY_TRANSITION_OFFSET,
  });

  return (
    <Fragment>
      <InView as="div" threshold={0} trackVisibility delay={100} initialInView>
        {({ inView, ref }) => (
          <div ref={ref}>
            <BrandPrinciplesHero slides={brandPrinciples} isInView={inView} />
          </div>
        )}
      </InView>

      <OverviewHero title={heroSections.title} slides={heroSections.slides} />

      <StyledContainer
        id={MODEL_COMPARE_V4_ANCHOR}
        size="desktop"
        noVerticalMargin
        $spacing={{ top: 44, bottom: 0 }}
      >
        <ModelCompareV4
          showBuyButton={compare.showBuyButton}
          section={compare.section}
          headerStickOffset={({ maxImageHeight }) =>
            maxImageHeight + MODEL_COMPARE_STICK_OFFSET_CORRECTION
          }
        />
      </StyledContainer>

      {featureConfig?.blocks?.length && (
        <StyledContainer
          size="desktop"
          noVerticalMargin
          $spacing={{ top: 64, bottom: 32 }}
        >
          <CondensedFeatureGridInView cards={featureConfig.blocks} isOverview />
        </StyledContainer>
      )}

      <StyledContainer
        size="desktop"
        noVerticalMargin
        $spacing={{ top: 48, bottom: 16 }}
      >
        <MicrositeHeading
          title={t("commons.faq")}
          spacing={{ top: 0, bottom: 48 }}
          shouldApplyMobileSpacings
        />
        <UniFiGPT />
        <StyledQuestions title="" {...faq} />
      </StyledContainer>
    </Fragment>
  );
};
